import { deliveryTargetKey } from "./deliveryCalendar";

// Cible de livraison : un EHPAD entier (sans sous-groupe) ou l'un de ses sous-groupes de production.
export function fullDeliveryTarget(ehpad, ehpadSubcategory = "") {
    return { ehpadId: ehpad.id, ehpadSubcategory, code: ehpad.code, nom: ehpad.nom, tournee: ehpad.tournee };
}

// Formulaire d'édition repris d'une livraison planifiée.
export function planningToForm(planning) {
    return {
        label: planning.label ?? "",
        firstDeliveryDate: planning.firstDeliveryDate ?? "",
        deliveryTime: planning.deliveryTime ? planning.deliveryTime.slice(0, 5) : "",
        frequency: planning.frequency ?? "HEBDOMADAIRE",
        frequencyDays: planning.frequencyDays ?? 7,
        driverId: planning.driverId ? String(planning.driverId) : "",
        notes: planning.notes ?? "",
        targets: (planning.ehpads ?? []).map(ehpad => ({
            ehpadId: ehpad.id,
            ehpadSubcategory: ehpad.ehpadSubcategory || "",
            code: ehpad.code,
            nom: ehpad.nom,
            tournee: ehpad.tournee,
        })),
    };
}

// Corps envoyé au serveur pour créer ou modifier une livraison.
export function deliveryPayload(form) {
    return {
        label: form.label,
        firstDeliveryDate: form.firstDeliveryDate,
        deliveryTime: form.deliveryTime || null,
        frequency: form.frequency,
        frequencyDays: Number(form.frequencyDays) || 7,
        driverId: form.driverId ? Number(form.driverId) : null,
        notes: form.notes || null,
        targets: form.targets.map(target => ({
            ehpadId: target.ehpadId,
            ehpadSubcategory: target.ehpadSubcategory || null,
        })),
        ehpadIds: form.targets.map(target => target.ehpadId),
    };
}

export function withToggledTarget(form, target) {
    const key = deliveryTargetKey(target);
    return {
        ...form,
        targets: form.targets.some(item => deliveryTargetKey(item) === key)
            ? form.targets.filter(item => deliveryTargetKey(item) !== key)
            : [...form.targets, target],
    };
}

export function withPlanningMode(form, mode) {
    return {
        ...form,
        frequency: mode,
        frequencyDays: mode === "PONCTUELLE" ? 7 : Number(form.frequencyDays) || 7,
    };
}

export function withFrequencyDays(form, value) {
    return {
        ...form,
        frequency: form.frequency === "PONCTUELLE" ? "PONCTUELLE" : "HEBDOMADAIRE",
        frequencyDays: value,
    };
}
